import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from '@tcc/i18n';
import styles from '../cardAndPreview/cardAndPreview.css';
import PreviewNavigationCard from '../cardAndPreview/PreviewNavigationCard';

import { LOCALE_GROUPS } from '../../../constants/units';
import { toDateString } from '../../../utils/date';
import { createUnit } from '../../../i18n/unitQtyWrapper';

function CropWaterUsePreview({
  date,
  precipitation,
  onLeftClick,
  onRightClick,
  locale,
}) {
  const time = toDateString(date, locale);
  const precipLocalized = createUnit(Number(precipitation.q), precipitation.u)
    .forLocaleGroup(LOCALE_GROUPS.CROP_WATER_USE)
    .toString();

  return (
    <PreviewNavigationCard
      onLeftClick={onLeftClick}
      onRightClick={onRightClick}
      testId="dmb-cropWaterUse-preview"
    >
      <div className={styles.column}>
        <div
          className={styles.value}
          data-test-id="fha-preview-card-current-date"
        >
          {time}
        </div>
        <h3 data-test-id="fha-preview-event-data">
          <span>
            {`${precipLocalized} ${getMessage(
              'card.avgdailywateruse.avgdailywateruse'
            )}`}
          </span>
        </h3>
      </div>
    </PreviewNavigationCard>
  );
}

CropWaterUsePreview.propTypes = {
  date: PropTypes.string.isRequired,
  locale: PropTypes.string,
  onLeftClick: PropTypes.func,
  onRightClick: PropTypes.func,
  precipitation: PropTypes.object,
};

export default CropWaterUsePreview;
